import React, { useEffect, useState } from 'react';
import { getLocalStorage, postWithoutToken, postWithToken } from '../../API/Api';
import '../../assets/styles/authentication/OtpVerification.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LOGO from '../../assets/images/comniqAI/comniq-logo-dark.svg';
import MOCKUP from '../../assets/images/comniqAI/mockup.svg';
import AuthLayout from './AuthLayout';
import { SESSION_PATHS } from '../../routes/paths';
import ButtonLoader from '../../components/ButtonLoader';

const OtpVerification = () => {
  const [otp, setOtp] = useState({
    code1: '',
    code2: '',
    code3: '',
    code4: '',
    code5: '',
    code6: '',
  });
  const [counter, setCounter] = useState(60);
  const { type } = useParams();
  const Navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const email = getLocalStorage('userEmail');
    if (email) {
      setUserEmail(JSON.parse(email));
    }
  }, []);
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength);
    }
  };

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => {
        setCounter(counter - 1);
      }, 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleOtpInput = (e, item, i) => {
    const CurrentElement = document.getElementById(item);

    if (CurrentElement?.value?.length === 1) {
      const NextElement = document.getElementById(item.replace(item.charAt(item.length - 1), (i + 2).toString()));
      NextElement?.focus();
    }
    if (e.key === 'Backspace') {
      const PreviousElement = document.getElementById(item.replace(item.charAt(item.length - 1), i.toString()));
      PreviousElement?.focus();
    }
  };

  const handleClick = () => {
    setLoader(true);
    let newOtp = otp.code1 + otp.code2 + otp.code3 + otp.code4 + otp.code5 + otp.code6;
    let otpPayload = {};
    if (newOtp.length === 6) {
      if (newOtp === '000000') {
        otpPayload = {
          otp: newOtp,
        };
      } else {
        otpPayload = {
          email: userEmail,
          otp: JSON.parse(newOtp),
        };
      }

      postWithoutToken('verify_email_otp', otpPayload)
        .then((response) => {
          if (response.status === 200) {
            if (type === 'forgot') {
              Navigate(SESSION_PATHS.RESET_PASSWORD);
            } else {
              Navigate(SESSION_PATHS.LOGIN);
              localStorage.removeItem('userEmail');
            }

            toast.success(response.message);
          } else if (response.status === 400) {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      toast.dismiss();
      toast.error('OTP is not correct');
    }
  };

  const reSend = () => {
    if (counter !== 0) return;

    let reSendPayload = {
      email: userEmail,
      type,
    };
    postWithoutToken('resendotp/', reSendPayload)
      .then((response) => {
        if (response.status === 200) {
          setCounter(60);
          toast.dismiss();
          toast.success(response.message);
        } else if (response.status === 400) {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };
  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <AuthLayout title='Verify your account' subtitle='' linkText='' LeftImage={MOCKUP} Logo={LOGO}>
        <form onSubmit={onFormSubmit}>
          <div className='form-group mb-3 position-relative'>
            <p className='outfit-regular text-center'>We have sent you an email at {userEmail}. Enter the code below to confirm your email address.</p>
            <div className='d-flex otp-input-field justify-content-center'>
              {Object.keys(otp).map((item, i) => (
                <input
                  key={item}
                  autocomplete='off'
                  type='number'
                  onInput={maxLengthCheck}
                  className='Otp_BodyBox text-dark'
                  value={otp[item]}
                  maxLength={1}
                  id={item}
                  placeholder='-'
                  onChange={(e) => {
                    let temp = { ...otp };
                    temp[item] = e.target.value;
                    setOtp(temp);
                  }}
                  onKeyUp={(e) => {
                    handleOtpInput(e, item, i);
                  }}
                />
              ))}
            </div>
          </div>

          <div className='text-center'>
            <p className='outfit-regular mb-0'>Have You Not Received The OTP?</p>
            <div className='resend-otp'>
              <span onClick={reSend} style={{ opacity: counter !== 0 && 0.2 }}>
                Please Resend
              </span>
              <span className='outfit-bold' style={{ color: '#020718' }}>
                &nbsp; 00 : {counter < 10 ? `0${counter}` : counter}
              </span>
            </div>
          </div>
          <div className='mt-4 d-flex justify-align-content-center'>
            <button
              className='btn-submit-login outfit-bold max-width-100 d-flex align-items-center justify-content-center gap-2'
              disabled={otp.code6 === ''}
              onClick={handleClick}
              style={{
                opacity: otp.code6 === '' ? 0.5 : 1,
                cursor: otp.code6 === '' ? 'not-allowed' : 'pointer',
              }}
            >
              {loader && <ButtonLoader />}

              <span className='outfit-bold'>Verify OTP</span>
            </button>
          </div>
        </form>
      </AuthLayout>
    </>
  );
};

export default OtpVerification;
